export const handleQuestionsInitialAdjustments = (
  questionnaire,
  setPeriodicityText,
  operation,
  isMasNy
) => {
  return questionnaire.map(question => {

    if (question.idQuestion === 676) {
      const { idAnswerOption } = question;
      if (idAnswerOption === 4599) {
        setPeriodicityText(questionnaire.find(q => q.idQuestion === 1200)?.dsQuestion || '-')
      } else {
        setPeriodicityText(questionnaire.find(q => q.idQuestion === 1199)?.dsQuestion || '-')
      }
    }

    if (question.idQuestion === 1193) {
      const qst = questionnaire.find(v => v.idQuestion === 675);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 4597;
    }

    if (question.idQuestion === 1194 || question.idQuestion === 1195) {
      const qst = questionnaire.find(v => v.idQuestion === 679);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 4604;
      question.behaviorObject.isRequired = idAnswerOption === 4604;
      if (idAnswerOption === 4605) {
        question.answer = ""
        question.idAnswerOption = null
      }
    }

    if (question.idQuestion === 1174) {
      const qst = questionnaire.find(v => v.idQuestion === 680);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 4606;
      if (idAnswerOption === 4607) {
        question.idAnswerOption = null
        question.answer = ""
      }
    }

    if (question.idQuestion === 1190) {
      const hasAnswer = question.answer?.length;
      question.childrenQuestions = question.childrenQuestions?.map(v => {
        v.behaviorObject.isRequired = !!hasAnswer;
        return v
      });
    }

    if (question.idQuestion === 1197) {
      const qst = questionnaire.find(v => v.idQuestion === 1196);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 6119;
      if (idAnswerOption === 6120) {
        question.idAnswerOption = null
        question.answer = ""
      }
    }

    if (question.idQuestion === 712) {
      const qst = questionnaire.find(v => v.idQuestion === 673);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 4691;
    }

    if (question.idQuestion === 1177) {
      const qst = questionnaire.find(v => v.idQuestion === 681);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 4608;
    }

    if (question.idQuestion === 1175) {
      const qst = questionnaire.find(v => v.idQuestion === 1174);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 6073;
    }

    // Novas questions - produto 48
    if (question.idQuestion === 1246) {
      const qst = questionnaire.find(v => v.idQuestion === 1245);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 6236;
    }

    if (question.idQuestion === 1248) {
      const qst = questionnaire.find(v => v.idQuestion === 1247);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 6238;
    }

    if (question.idQuestion === 1236 && (operation && operation?.idDomainStatus === 1)) {
      question.visibleQuestion = false;
    }

    if (question.idQuestion === 1252) {
      const qst = questionnaire.find(v => v.idQuestion === 673);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 4691;
    }

    if (question.idQuestion === 1384) {
      const chargeType = JSON.parse(questionnaire.find(v => v.idQuestion === 1383)?.answer || null);
      if (chargeType?.id) {
        question.fieldMask = chargeType.id == 629 ?
          {
            "type": "percentage",
            "mask": "% num",
            "blocks": {
              "num": {
                "mask": 0,
                "scale": 5,
                "signed": true,
                "normalizeZeros": false,
                "padFractionalZeros": true,
                "thousandsSeparator": ",",
                "radix": ".",
                "mapToRadix": [
                  ".",
                  ","
                ],
                "min": -100,
                "max": 100
              }
            }
          } : {
            "type": "currency",
            "mask": 0,
            "scale": 2,
            "signed": false,
            "normalizeZeros": false,
            "padFractionalZeros": true,
            "radix": ".",
            "thousandsSeparator": ",",
            "mapToRadix": [
              ".",
              ","
            ],
            "max": 999999999999.99,
            "min": -999999999999.99
          }
      }
    }

    if (question.idQuestion === 1386) {
      const qst = questionnaire.find(v => v.idQuestion === 1384);
      const { answer } = qst;
      question.visibleQuestion = answer == 0 || answer == "% 0.00000" || answer == "0.00";
      question.isRequired = answer == 0 || answer == "% 0.00000" || answer == "0.00";
      question.behaviorObject.isRequired = answer == 0 || answer == "% 0.00000" || answer == "0.00";
    }
    
    if ([1433].includes(question.idQuestion)) {
      const tax = questionnaire.find(question => question.idQuestion === 1464);

      for (const q of tax.childrenQuestions) {
        if (q.idQuestion === 1796 || q.idQuestion === 1797) {
          q.behaviorObject.isRequired = question.idAnswerOption === 7012;
          q.visibleQuestion = question.idAnswerOption === 7012;
        }
      }
    }

    if (question.idQuestion === 1464) {
      question.disabled = true;
    }

    if(question.idQuestion === 1465) { 
      question.visibleQuestion = operation?.idProduct === 47;
      question.disabled = operation?.idProduct === 47 ? false : true;
      question.behaviorObject.desktopWidth = 10;
      question.behaviorObject.tabletWidth = 10;
      question.behaviorObject.mobileWidth = 10;
    }

    if (question.idQuestion === 1796 && question.idAnswerOption) {
      questionnaire.map(qst => {
        if (qst.idQuestion === 1797) {
          qst.behaviorObject.administeredByAnswer = question.idAnswerOption || null;  
        }  
        return qst;
      })
    }

    if (question.idQuestion === 1796 && question.idAnswerOption) {
      questionnaire.map(qst => {
        if (qst.idQuestion === 1797) {
          qst.behaviorObject.administeredByAnswer = question.idAnswerOption || null;  
        }  
        return qst;
      })
    }

    return question;
  })
}

export const handleQuestionChange = (
  question,
  value,
  filteredQuestionnaire,
  setFilteredQuestionnaire,
  setFieldValue,
  questionnaire,
  setPeriodicityText,
  setCurrentModality
) => {
  let saveFilteredQuestionnaire = false;

  if (question.idQuestion === 676) {
    const { idAnswerOption } = value;
    if (idAnswerOption === 4599) {
      setPeriodicityText(questionnaire.find(q => q.idQuestion === 1200)?.dsQuestion || '-')
    } else {
      setPeriodicityText(questionnaire.find(q => q.idQuestion === 1199)?.dsQuestion || '-')
    }
  }

  if (question.idQuestion === 675) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1193) {
        qst.visibleQuestion = idAnswerOption === 4597;
      }
      return qst;
    })
  }

  if (question.idQuestion === 679) {
    saveFilteredQuestionnaire = true;

    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if ([1194, 1195].includes(qst.idQuestion)) {
        qst.visibleQuestion = idAnswerOption === 4604;
        qst.behaviorObject.isRequired = idAnswerOption === 4604;
        if (idAnswerOption === 4605) {
          qst.answer = "";
          qst.idAnswerOption = null
        }
      }

      return qst;
    })
  }

  if (question.idQuestion === 680) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1174) {
        qst.visibleQuestion = idAnswerOption === 4606;
        if (idAnswerOption === 4607) {
          qst.idAnswerOption = null
          qst.answer = ""
        }
      }
      return qst;
    })
  }

  if (question.idQuestion === 1190) {
    saveFilteredQuestionnaire = true;

    const questonIndex = parseFloat(filteredQuestionnaire.find(qst => qst.idQuestion === 1190).answer || 0)
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1191) {
        if (questonIndex > 0) {
          qst.behaviorObject.isRequired = true
        } else {
          qst.behaviorObject.isRequired = false
        }
      }

      if (qst.idQuestion === 1192) {
        if (questonIndex > 0) {
          qst.behaviorObject.isRequired = true
        } else {
          qst.behaviorObject.isRequired = false
        }
      }
      return qst;
    })
  }

  if (question.idQuestion === 1196) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1197) {
        qst.visibleQuestion = idAnswerOption === 6119;
        if (idAnswerOption === 6120) {
          qst.idAnswerOption = null;
          qst.answer = ""
        }
      }
      return qst;
    })
  }

  if (question.idQuestion === 673) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 712) {
        qst.visibleQuestion = idAnswerOption === 4691;
      }

      if (qst.idQuestion === 1252) {
        qst.visibleQuestion = idAnswerOption === 4691;
      }

      return qst;
    })
  }

  if (question.idQuestion === 680) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1174) {
        qst.visibleQuestion = idAnswerOption === 4606;
      }
      if (qst.idQuestion === 1175 && idAnswerOption === 4607) {
        qst.visibleQuestion = idAnswerOption === 4606;
        if (idAnswerOption === 4607) {
          qst.idAnswerOption = null;
          qst.answer = ""
        }
      }
      return qst;
    })
  }

  if (question.idQuestion === 1174) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1175) {
        qst.visibleQuestion = idAnswerOption === 6073;
        if (idAnswerOption === 6074) {
          qst.answer = "";
          qst.idAnswerOption = null;
        }
      }
      return qst;
    })
  }

  if (question.idQuestion === 681) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1177) {
        qst.visibleQuestion = idAnswerOption === 4608;
        if (idAnswerOption === 4609) {
          qst.answer = "";
          qst.idAnswerOption = null;
        }
      }
      return qst;
    })
  }

  if (question.idQuestion === 1236) {
    handleTypeModalityChange(question, value, setCurrentModality)
  }

  if (question.idQuestion === 1245) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1246) {
        qst.visibleQuestion = idAnswerOption === 6236;
      }
      return qst;
    })
  }

  if (question.idQuestion === 1247) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1248) {
        qst.visibleQuestion = idAnswerOption === 6238;
      }
      return qst;
    })
  }

  if (question.idQuestion === 1383) {
    saveFilteredQuestionnaire = true;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1384) {
        if (value?.id) {
          qst.fieldMask = value.id == 629 ? {
            "type": "percentage",
            "mask": "% num",
            "blocks": {
              "num": {
                "mask": 0,
                "scale": 5,
                "signed": true,
                "normalizeZeros": false,
                "padFractionalZeros": true,
                "thousandsSeparator": ",",
                "radix": ".",
                "mapToRadix": [
                  ".",
                  ","
                ],
                "min": -100,
                "max": 100
              }
            }
          } : {
            "type": "currency",
            "mask": 0,
            "scale": 2,
            "signed": false,
            "normalizeZeros": false,
            "padFractionalZeros": true,
            "radix": ".",
            "thousandsSeparator": ",",
            "mapToRadix": [
              ".",
              ","
            ],
            "max": 999999999999.99,
            "min": -999999999999.99
          }
        }
        qst.answer = "";
        qst.answerJson = "";
        setFieldValue && setFieldValue(qst.key, "");
      }
      return qst;
    })
  }

  if (question.idQuestion === 1384) {
    saveFilteredQuestionnaire = true;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1386) {
        qst.visibleQuestion = value == "0";
        qst.isRequired = value == "0";
        qst.behaviorObject.isRequired = value == "0";
        qst.answer = "";
        qst.answerJson = "";
        setFieldValue && setFieldValue(qst.key, "");
      }
      return qst;
    })
  }

  if ([1433].includes(question.idQuestion)) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;

    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if ([1796, 1797].includes(qst.idQuestion)) {
        qst.visibleQuestion = idAnswerOption === 7012;
        qst.behaviorObject.isRequired = idAnswerOption === 7012;
      }

      return qst;
    })
  }

  if(question.idQuestion === 1796) {
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1797) qst.behaviorObject.administeredByAnswer = value?.idAnswerOption || null;

      return qst;
    })
  }

  if (saveFilteredQuestionnaire) setFilteredQuestionnaire(filteredQuestionnaire);
}

const handleTypeModalityChange = (question, value, setCurrentModality) => {
  const answerOption = question.answerOptions.find(answerOption => answerOption.idAnswerOption === value.idAnswerOption);
  const { resultProductPlan } = answerOption?.behaviorObject || {};

  if (resultProductPlan) {
    setCurrentModality && setCurrentModality(resultProductPlan);
  }
}

export const handleRequestSerproCnpj = async (rootQuestion, data, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) => {
  try {
    filteredQuestionnaire = filteredQuestionnaire.map(question => {
      if (rootQuestion.idQuestion === 658 && question.idQuestion === 660) {
        setFieldValue && setFieldValue(question.key, data.nomeEmpresarial);
        return ({ ...question, answer: data.nomeEmpresarial, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 658 && question.idQuestion === 658) {
        setFieldValue && setFieldValue(question.key, data.ni);
        return ({ ...question, answer: data.ni, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 1234 && question.idQuestion === 1235) {
        setFieldValue && setFieldValue(question.key, data.nomeEmpresarial);
        return ({ ...question, answer: data.nomeEmpresarial, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 1234 && question.idQuestion === 1234) {
        setFieldValue && setFieldValue(question.key, data.ni);
        return ({ ...question, answer: data.ni, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 1234 && question.idQuestion === 1307) {
        const answerOptionDeclined = question.answerOptions.find(option => option.idAnswerOption === 6605);
        question.idAnswerOption = answerOptionDeclined?.idAnswerOption;
        question.answer = answerOptionDeclined?.dsAnswerOption;
        setFieldValue && setFieldValue(question.key, question);

        return ({ ...question, answer: answerOptionDeclined.dsAnswerOption, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 1235 && question.idQuestion === 1307) {
        const answerOptionDeclined = question.answerOptions.find(option => option.idAnswerOption === 6605);
        question.idAnswerOption = answerOptionDeclined?.idAnswerOption;
        question.answer = answerOptionDeclined?.dsAnswerOption;
        setFieldValue && setFieldValue(question.key, question);

        return ({ ...question, answer: answerOptionDeclined.dsAnswerOption, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 1225 && question.idQuestion === 1226) {
        setFieldValue && setFieldValue(question.key, data.nomeEmpresarial);
        return ({ ...question, answer: data.nomeEmpresarial, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 1225 && question.idQuestion === 1225) {
        setFieldValue && setFieldValue(question.key, data.ni);
        return ({ ...question, answer: data.ni, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 661 && question.idQuestion === 662) {
        setFieldValue && setFieldValue(question.key, data.nomeEmpresarial);
        return ({ ...question, answer: data.nomeEmpresarial, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 661 && question.idQuestion === 661) {
        setFieldValue && setFieldValue(question.key, data.ni);
        return ({ ...question, answer: data.ni, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 663 && question.idQuestion === 664) {
        setFieldValue && setFieldValue(question.key, data.nomeEmpresarial);
        return ({ ...question, answer: data.nomeEmpresarial, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 663 && question.idQuestion === 663) {
        setFieldValue && setFieldValue(question.key, data.ni);
        return ({ ...question, answer: data.ni, answerJson: undefined });
      }

      if (question.idQuestion === 759) {
        setFieldValue && setFieldValue(question.key, data.ni);
        return ({ ...question, answer: data.ni, answerJson: undefined });
      }
      if (rootQuestion.idQuestion === 759 && question.idQuestion === 760) {
        setFieldValue && setFieldValue(question.key, data.ni);
        return ({ ...question, answer: data.ni, answerJson: undefined });
      }

      return question;
    })

    setFilteredQuestionnaire(filteredQuestionnaire);
  } catch (e) {
    console.log('handleRequestSerproCnpj error', e)
  }
};

export const onValidationError = (e, mc, formikRef, questionnaire, groupQuestionnaires) => {
  mc.error('Please complete all required fields to proceed.')
  const allQuestions = questionnaire;
  groupQuestionnaires.map(questionnaire => questionnaire.map(question => allQuestions.push(question)));

  let firstErrorKey = null;
  try {
    for (const question of allQuestions) {
      if (!formikRef.current.errors || !formikRef.current.errors[question.key]) continue;
      formikRef.current.setFieldError(question.key, null);
    }

    e.inner.map(({ message, path }) => {
      const question = allQuestions.find(question => question.key === path);
      if (question) mc.error(`The Field ${question.dsQuestion} is Required`);
      if (e.message === "Email inválido") formikRef.current.setFieldError(question.key, `* Email inválido`);
      else formikRef.current.setFieldError(question.key, `* Required Field`);
      if (!firstErrorKey) firstErrorKey = question.key;
    })

    if (firstErrorKey) {
      const elements = global.window.document.getElementsByName(firstErrorKey);
      if (elements?.length) {
        setTimeout(() => elements[0].scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' }), 300);
      }
    }
  } catch (e) {
    console.log('onValidationError catch', e)
  }
}

export const sectionIsVisible = (sectionName, questionnaire) => {
  return questionnaire
    .some(question => question?.behaviorObject?.sectionName === sectionName)
}

const getQuestionIsDisabled = (question, operation, isBound, exisitsTaxes) => {
  if (exisitsTaxes) return false;
  if ([1378, 1379, 1378, 1380, 1381, 1382].includes(question.idQuestion)) return true;
  if (isBound) return true;
  return false;
}

export const groupMultipleFieldQuestions = (mainIdQuestion, questionnaire, operation, isBound, exisitsTaxes) => {
  const groupQuestions = [];

  const mainQuestions = questionnaire.filter(question => question.idQuestion === mainIdQuestion);
  const mainQuestionIndex = questionnaire.findIndex(question => question.idQuestion === mainIdQuestion);

  for (const mainQuestion of mainQuestions) {
    let group = []

    if (mainQuestionIndex || mainQuestionIndex == 0) group.push(questionnaire[mainQuestionIndex]);

    if (mainQuestionIndex != -1) questionnaire.splice(mainQuestionIndex, 1);
    
    if (mainQuestion && mainQuestion.childrenQuestions && mainQuestion.childrenQuestions.length > 0) {
      mainQuestion.childrenQuestions.map(childQuestion => {
        group.push(childQuestion)
      });
    }

    group.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);
    groupQuestions.push(group.map((question, index) => ({ ...question, disabled: getQuestionIsDisabled(question, operation, isBound, exisitsTaxes) })));
  }

  return groupQuestions;
}

export const removeAnswersDuplicateSession = (questions) => {
  questions = JSON.parse(JSON.stringify(questions));
  return questions.map(question => {
    const { defaultValue } = question.behaviorObject || {};
    question.answer = defaultValue || "";
    question.answerJson = defaultValue || "";
    question.idAnswerOption = null;
    question.idPerson = null;
    question.idQuestionnaireAnswers = null;
    question.idQuestionnaireAnswersParent = null;
    question.idQuestionnaireAnswersRoot = null;
    question.key = null;
    question.disabled = false;
    return question;
  })
}
